import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';

export interface InsertTextConfig {
  items: Array<{ label: string; textToInsert: string }>;
}

@Component({
  selector: 'csi-custom-message',
  templateUrl: './custom-message.component.html',
  styleUrls: ['./custom-message.component.css']
})
export class CustomMessageComponent {
  @Input() title!: string; // Required: Dynamic title
  @Input() description!: string; // Required: Help text or description
  @Input() insertTextConfig!: InsertTextConfig; // Required: Insert text options
  @Input() control: FormControl;

  public translations: Record<string, string> = {};
  private translationSub: Subscription;

  constructor(private translocoService: TranslocoService) {}

  ngOnInit() {
    this.translationSub = this.translocoService
      .selectTranslateObject('welcomeMessage')
      .subscribe(map => {
        this.translations = map;
      });
  }
}
